<template>
  <div class="auth-content">
    <div class="auth-title"><strong>LEVEL 1</strong> {{ $t('Verification.common.verification.title') }}{{$t("Verification.common.required")}}</div>
    <div class="sub-title-box" flex fjb>
      <div class="sub-title">- {{ $t('Verification.common.verification.description') }}</div>
      <div class="right-wrap" flex>
      <!-- 준비사항 -->
      <div @click="clickReadyModal" class="fs12">
        {{ $t('Verification.common.ready.title') }}
        <img src="@/assets/img/mypage/question-mark.png" alt="" style="opacity: 0.5; padding-top: 9px">
      </div>
      <!-- //준비사항 -->
      <!-- 정보보기 -->
      <div v-if="(userInfo.dueDiligenceInfo && userInfo.dueDiligenceInfo.sbStatus == 'E') || (userInfo.dueDiligenceInfo && userInfo.dueDiligenceInfo.sbStatus == 'RE')" @click="showauthinfo" class="green-round ml10 pr12 pl12">
        {{ $t('Verification.userInfo.title') }}
      </div>
      <!-- //정보보기 -->
      </div>

      
    </div>
    <div class="pb10 fs12">
      <p class="pb3">{{"주민등록증 및 운전면허증 필수 지참!"}}</p>
      
    </div>

    <!-- 신원인증 승인 후 -->
    <!-- <div v-if="false" class="auth-line auth" flex fjb> -->
    <div v-if="(userInfo.dueDiligenceInfo && userInfo.dueDiligenceInfo.sbStatus == 'E') || (userInfo.dueDiligenceInfo && userInfo.dueDiligenceInfo.sbStatus == 'RE')" class="auth-line auth" flex fjb>
      <div class="data" flex>
        <div class="icon-identity"></div>
        <div class="ml29">
          {{ userInfo.name }}<br>
          {{ userInfo.dueDiligenceInfo.mBirth }}<span class="ml8">{{phoneNumberMasking(userInfo.mPhone)}}</span>
        </div>
      </div>
      <div class="status">
        {{ $t("mypage.verify.verificationComplete") }}
          <img src="@/assets/img/mypage/check_ic.svg" class="ml4" alt="">
      </div>
      <div v-if="userInfo.dueDiligenceInfo&&userInfo.dueDiligenceInfo.sbStatus == 'RE'" @click="clickProcessModal" class="process ta-c">
        <p class="noti">{{ $t('Verification.common.pass') }}</p>
      </div>
    </div>
    <!-- //신원인증 승인 후 -->

    <!-- 신원인증 전 -->
    <div v-else class="w12 auth-line" flex fic fjs>
      <div class="data full" flex fjb>
        <div flex fjb>
          <div class="icon-identity"></div>
          <div class="value" flex>
            {{ "신원 인증은 플라이빗 앱 (App)에서 가능합니다." }}
            <div v-if="userInfo.dueDiligenceInfo && userInfo.dueDiligenceInfo.sbStatus == 'J'">
              <p class="reject keycolor ml5 mb0">
                {{ $t('Verification.common.reject') }}
              </p>
            </div>
          </div>
        </div>
        <!-- <img src="@/assets/img/mypage/button_arrow_right_icon.svg" alt=""> -->
      </div>
      <div v-if="userInfo.dueDiligenceInfo && userInfo.dueDiligenceInfo.sbStatus == 'R'" @click="clickProcessModal" class="process ta-c">
        <p class="noti">{{ $t('Verification.common.pass') }}</p>
      </div>
    </div>
    <!-- //신원인증 전 -->

    <!-- 신원인증 준비사항 팝업 -->
    <vs-popup 
      :title="$t('Verification.common.verification.preparations')"
      :button-close-hidden="true" :active.sync="readyModal"
      class="medium-popup"
    >
    <div class="text-wrap">
      <div class="text-detail">
        <div class="text-box mt0">
          <!-- 내국인 -->
          <p class="center">
           {{ $t('Verification.common.verification.preparationsSub') }}
          </p>
          <p class="title mb0 mt10">
            {{$t('mypage.human[0]')}}
          </p>
          <div class="contents gray-box mt9">
            <div class="list">
              <p class="fw500 mb0">
                {{$t('Verification.common.ready.list[0]')}}
              </p>
              <div class="item mt7" v-html="$t('Verification.common.ready.list[1]')">
              </div>
            </div>
            <div class="list mt13">
                {{$t('Verification.common.ready.list[2]')}}
              <div class="item mt5">
              {{$t('Verification.common.ready.list[3]')}}
              </div>
            </div>
          </div>
          <!-- //내국인 -->
          <!-- 국내 거주 외국인 -->
          <!-- <p class="title mt24 mb0">
            {{$t('mypage.human[2]')}}
          </p>
          <div class="contents gray-box mt9">
            <div class="list">
              <p class="fw500 mb0">
                {{$t('Verification.common.ready.listForeignerKR[0]')}}
              </p>
              <div class="item mt4">
                {{$t('Verification.common.ready.listForeignerKR[1]')}}
              </div>
              <div class="item mt4">
                {{$t('Verification.common.ready.listForeignerKR[2]')}}
              </div>
            </div>
          </div> -->
          <!-- //국내 거주 외국인 -->
          <!-- 국내 비거주 외국인 -->
          <!-- <p class="title mt24 mb0">
            {{$t('mypage.human[3]')}}
          </p>
          <div class="contents gray-box mt9">
            <div class="list">
              <p class="fw500 mb0">
                {{$t('Verification.common.ready.listForeignerOthers[0]')}}
              </p>
              <div class="item mt7" v-html="$t('Verification.common.ready.listForeignerOthers[1]')">
              </div>
              <div class="item mt4">
                {{$t('Verification.common.ready.listForeignerOthers[2]')}}
              </div>
            </div>
            <div class="list mt10 pt10 line">
              <p class="fw500 mb0">
                {{$t('Verification.common.ready.listForeignerOthers[3]')}}
              </p>
              <div class="mt5">
                {{$t('Verification.common.ready.listForeignerOthers[4]')}}
              </div>
              <div class="list mt10 pt10 line">
                <p class="fw500 mb0">
                  {{$t('Verification.common.ready.listForeignerOthers[5]')}}
                </p>
                <div class="mt5 keycolor">
                  {{$t('Verification.common.ready.listForeignerOthers[6]')}}
                </div>
                <div class="mt5">
                  {{$t('Verification.common.ready.listForeignerOthers[7]')}}
                </div>
                <div class="mt5">
                  {{$t('Verification.common.ready.listForeignerOthers[8]')}}
                </div>
                <div class="mt5">
                  {{$t('Verification.common.ready.listForeignerOthers[9]')}}
                </div>
              </div>
            </div>
          </div> -->
          <!-- //국내 비거주 외국인 -->
        </div>
      </div>
    </div>
    <div class="button-wrap">
      <button @click="readyModal = false">
        {{$t('confirm.ok')}}
      </button>
    </div>
    </vs-popup>
    <!-- //신원인증 준비사항 팝업 -->

    <!-- 신원인증 심사 중 팝업 -->
    <vs-popup 
      :title="$t('Verification.popup.process.title')"
      :button-close-hidden="true" :active.sync="processModal"
      class="medium-popup"
    >
    <div class="text-wrap">
      <div class="text-detail">
        <div class="text-box mt0">
          <!-- <p class="title">
            {{$t('Verification.popup.process.subTitle')}}
          </p> -->
          <div class="contents gray-box">
            <div class="list">
              <div class="item" v-html="$t('Verification.popup.process.description')">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="button-wrap">
      <button @click="processModal = false">{{$t('confirm.ok')}}</button>
    </div>
    </vs-popup>
    <!-- //신원인증 심사 중 팝업 -->
  </div>
</template>

<script>
// import Api from "@/common/Api";
import { mapGetters } from "vuex";
import Masking from "@/common/masking.js"
// import Moment from "moment";
// import GlobalEvent from '@/common/Event';

export default {
  props: ["authData", "phone"],
  data() {
    return {
      readyModal: false,
      processModal: false
    };
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {
    authPhone() {
    },
    // 준비사항 모달
    clickReadyModal() {
      this.readyModal = true;
    },
    // 신원인증 심사중 모달
    clickProcessModal() {
      this.processModal = true;
    },
    // 신원인증 안내 페이지 연결
    clickAuthIdentity() {
      CookieControl.setCookie("retry", "N");
      this.$router.push({
        name: "authID",
        query: { reAuth: "N" }
      })
    },
    // 정보보기 버튼 클릭 시
    showauthinfo() {
      this.$router.push({name: "authInfo"})
    },
    // 전화번호 마스킹 : 뒤 3자부터 4자
    phoneNumberMasking(_value) {
      return Masking.phoneNumberMasking(_value);
    },
  },
  destroyed() {
    clearInterval(this.messageConfirmTimer);
  }
};
</script>

<style lang="scss" scoped src="./index.scss">
